import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "container",
    "progress",
    "progressText",
    "progressWrapper",
    "checkbox",
    "submitButton",
    "scrollComplete",
    "scrollPercentage",
    "form"
  ]

  connect() {
    this.isMobile = this.detectMobile()
    this.scrollCompleted = false
    this.maxScrollPercentage = 0
    this.pageLoadTime = Date.now()
    this.minTimeRequired = 5000 // 5 seconds minimum

    // Hide progress bar on mobile
    if (this.isMobile && this.hasProgressWrapperTarget) {
      this.progressWrapperTarget.style.display = 'none'
      // Enable checkbox immediately on mobile
      this.checkboxTarget.disabled = false
    }

    // Hide progress bar if content is short
    if ((this.containerTarget.scrollHeight <= this.containerTarget.clientHeight) &&
          this.hasProgressWrapperTarget) {
      this.progressWrapperTarget.style.display = 'none'
      this.markScrollComplete()
      // Enable checkbox immediately on mobile
      this.checkboxTarget.disabled = false
    }


    // Start time tracking
    this.startTime = Date.now()
  }

  detectMobile() {
    const userAgent = navigator.userAgent.toLowerCase()
    return /mobile|android|iphone|ipad|tablet/.test(userAgent) || window.innerWidth < 768
  }

  trackScroll(event) {
    if (this.isMobile) return // Skip scroll tracking on mobile

    const container = this.containerTarget
    const scrollTop = container.scrollTop
    const scrollHeight = container.scrollHeight
    const clientHeight = container.clientHeight

    // Calculate scroll percentage
    const maxScroll = scrollHeight - clientHeight
    const scrollPercentage = maxScroll > 0 ? Math.round((scrollTop / maxScroll) * 100) : 100

    // Update max scroll percentage
    this.maxScrollPercentage = Math.max(this.maxScrollPercentage, scrollPercentage)
    this.scrollPercentageTarget.value = this.maxScrollPercentage

    // Update progress bar
    if (this.hasProgressTarget) {
      this.progressTarget.value = scrollPercentage
      this.progressTextTarget.textContent = `Progress: ${scrollPercentage}%`
    }

    // Check if scrolled to bottom (with 5px tolerance for browser rendering differences)
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      this.markScrollComplete()
    }
  }

  markScrollComplete() {
    if (this.scrollCompleted) return // Already marked

    this.scrollCompleted = true
    this.scrollCompleteTarget.value = "true"
    this.scrollPercentageTarget.value = 100

    // Update UI
    if (this.hasProgressTarget) {
      this.progressTarget.value = 100
      this.progressTextTarget.classList.add('has-text-success')
    }

    // Enable checkbox
    this.checkboxTarget.disabled = false

    // Show a subtle notification
    //this.showNotification("You may now accept the terms", "success")
  }

  toggleSubmit(event) {
    // Enable submit button when checkbox is checked
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !event.target.checked
    }
  }

  beforeSubmit(event) {
    // Final validation before form submission
    const timeSpent = (Date.now() - this.pageLoadTime) / 1000

    // Check minimum time requirement (unless admin bypass)
    const bypassTiming = this.element.querySelector('[data-target="terms-acceptance.bypassTiming"]')?.value === "true"

    if (!bypassTiming && timeSpent < (this.minTimeRequired / 1000)) {
      event.preventDefault()
      this.showNotification("Please take time to read the terms and conditions", "danger")
      return false
    }

    // Desktop: Verify scroll completion (unless admin)
    if (!this.isMobile && !bypassTiming && !this.scrollCompleted) {
      event.preventDefault()
      this.showNotification("Please scroll to the bottom of the terms and conditions", "warning")
      return false
    }

    // Verify checkbox checked
    if (!this.checkboxTarget.checked) {
      event.preventDefault()
      this.showNotification("You must accept the terms and conditions to continue", "warning")
      return false
    }

    // All validations passed - allow form submission
    return true
  }

  showNotification(message, type = "info") {
    // Create temporary notification
    const notification = document.createElement('div')
    notification.className = `notification is-${type}`
    notification.textContent = message

    // Insert at top of page
    const container = document.querySelector('.container')
    if (container) {
      container.insertBefore(notification, container.firstChild)

      // Auto-remove after 5 seconds
      setTimeout(() => {
        notification.remove()
      }, 5000)
    }
  }
}
